module.exports = __webpack_public_path__ + "img/radiation.891379e6.svg";